import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '../../../app-routing.module';
import { ScriptHackModule } from '../script-hack/script-hack.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { Angular2SocialLoginModule } from 'angular2-social-login';
import { GoogleAdwordsConversionComponent } from './google-adwords-conversion.component';
import { GooglePatternNumberFormatter } from '../../services/google-pattern-number-formatter';

@NgModule({
    declarations: [
        GoogleAdwordsConversionComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        HttpModule,
        HttpClientModule,
        Angular2SocialLoginModule,
        AppRoutingModule,
        ScriptHackModule
    ],
    providers: [
        GooglePatternNumberFormatter
    ],
    bootstrap: [],
    exports: [
        GoogleAdwordsConversionComponent
    ]
})
export class GoogleAdwordsConversionModule {}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/shared/components/google-adwords-conversion/google-adwords-conversion.module.ts